export default {
      id: "nav_puce_pause-usage",
      viewBox: "0 0 12 13",
      url: "../dist/images/" + "sprite.svg#nav_puce_pause-usage",
      toString: function () {
        return this.url;
      }
    }